import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getMatterAllInfo } from "api";
import MatterLedger from "pages/MatterLedger/MatterLedger";
import { Loader } from "@progress/kendo-react-indicators";
import { Dialog } from "@progress/kendo-react-dialogs";
import { BiErrorCircle } from "react-icons/bi";

const StandaloneMatterLedger = () => {
  const { id } = useParams();
  const [matterData, setMatterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    import("../../styles/_standalone.scss");
  }, []);

  useEffect(() => {
    const fetchMatter = async () => {
      try {
        if (id) {
          const res = await getMatterAllInfo(id);
          setMatterData(res?.data?.data);
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (err) {
        setErrorMsg("Matter not found or access denied.");
        setLoading(false);
      }
    };

    fetchMatter();
  }, [id]);

  useEffect(() => {
    if (matterData && matterData.matterRef) {
      document.title = `Ledger ${matterData.matterRef} - Linq Law Hub`;
    } else {
      document.title = "Matter Ledger - Linq Law Hub";
    }
  }, [matterData]);

  if (loading) {
    return (
      <Loader
        themeColor={"primary"}
        size={"large"}
        type={"infinite-spinner"}
        style={{ position: "absolute", top: "40%", left: "45%", zIndex: 999 }}
      />
    );
  }

  if (errorMsg && id) {
    return (
      <Dialog width={400} height={230}>
        <div className="d-flex flex-column justify-content-around align-items-center h-100 px-5 text-center">
          <BiErrorCircle color="red" size={"50px"} />
          <p style={{ fontWeight: "500", fontSize: "18px" }}>{errorMsg}</p>
          <button
            className="common-btn border-0"
            onClick={() => navigate("/sa/matterledger")}
          >
            Close
          </button>
        </div>
      </Dialog>
    );
  }

  return (
    <div className="p-2 h-100 w-100 d-flex flex-column">
      <div
        className="d-flex justify-content-between align-items-center px-4 py-3"
        style={{ height: "50px" }}
      >
        <div className="app-bar-title">
          {matterData?.matterRef && (
            <h5 className="fw-semibold mb-0">
              Matter Ledger {matterData.matterRef}
              {matterData?.details && ` - ${matterData.details}`}
            </h5>
          )}
          {!matterData && <h5 className="fw-semibold mb-0">Matter Ledger</h5>}
        </div>
      </div>

      <div className="flex-grow-1 overflow-auto">
        <MatterLedger
          component="Standalone"
          initialMatterId={id ? parseInt(id) : null}
        />
      </div>
    </div>
  );
};

export default StandaloneMatterLedger;
